import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation, HostListener } from '@angular/core';
import { ModalChildComponent } from '@finder/shared/components/modal/modal-child-component.interface';
import { ModalComponent } from '@finder/shared/components/modal/modal.component';
import { SafeHtmlPipe } from '@finder/shared/utils/pipes/safe-html/safe-html.pipe';

@Component({
    selector: 'finder-read-more-modal',
    templateUrl: './read-more-modal.component.html',
    styleUrls: ['./read-more-modal.component.scss'],
    encapsulation: ViewEncapsulation.None, // I had to do this to get the css to apply to the innerHTML content
    standalone: true,
    imports: [
        CommonModule,
        SafeHtmlPipe
    ]
})
export class ReadMoreModalComponent implements ModalChildComponent {
    parentComponent: ModalComponent;
    data;

    // [PRO-346372] Don't allow the user to navigate to a link in the read more modal
    @HostListener('click', ['$event'])
    suppressClicks($event) {
        $event.preventDefault();
    }
}
